module.exports = __webpack_public_path__ + "img/new-guide-img4.e73efde0.png";